import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=081c51ba&scoped=true"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"
import style0 from "./LocaleChanger.vue?vue&type=style&index=0&id=081c51ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c51ba",
  null
  
)

export default component.exports